import React from 'react'
import Footer from '../../../general/footer/Footer';

import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
import aifimg1 from "../../../assets/aifimg1.jpg"
import { Link } from 'react-router-dom';

const AIF = () => {
  return (
    <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">Alternative Investment Funds</span>
                    </div>
                    <h1>Alternative Investment Funds</h1>
                    <p>
                        At PSJ Capital Ventures, we bring access to India's top-performing AIFs—carefully curated to fit various return expectations, liquidity profiles, and risk appetites—with complete advisory, onboarding, and reporting support.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={aifimg1} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    <h2>What Are Alternative Investment Funds (AIFs)?</h2>
                    <p>
                       Alternative Investment Funds (AIFs) are pooled investment vehicles registered with SEBI that invest in non-traditional assets and strategies—such as private equity, venture capital, private credit, long-short equity, structured products, and special situations—offering sophisticated investors access to high-growth and differentiated return opportunities.
                    </p>

                    <h3 style={{color:'black'}}>AIF Categories (As per SEBI Regulations)</h3>

                    <h5>Category I AIF</h5>
                    <p className="bold-line">
                        Focuses on early-stage or socially beneficial sectors. SEBI incentivizes these through relaxed norms and tax benefits.
                    </p>
                    <ul>
                      <li><h6>Types</h6>Venture Capital, SME Funds, Social Venture Funds, Infrastructure Funds.</li>
                      <li><h6>	Key Feature</h6>Invest in startups, emerging sectors, government-prioritized areas.</li>
                      <li><h6>	Liquidity</h6>5–10 year lock-in; closed-end.</li>
                      <li><h6>		Examples</h6>	Chiratae Ventures, 	Blume Ventures,	Bharat Innovation Fund</li>
                    </ul>
                    <h5>Category II AIF</h5>
                    <p className="bold-line">
                        Includes private equity, private debt, structured credit, and real estate funds. Most popular among HNIs and family offices.
                    </p>
                    <ul>
                      <li><h6>Types</h6>Private Equity, Real Estate, Credit Opportunities, Distressed Assets.</li>
                      <li><h6>	Key Feature</h6>No leverage; invests in long-term opportunities.</li>
                      <li><h6>	Liquidity</h6>Lock-in between 3–7 years; closed-end.</li>
                      <li><h6>		Examples</h6>	Motilal Oswal PE Fund,
	Edelweiss Yield Plus Fund,
	Avendus Structured Credit Fund,
	IIFL Special Opportunities Fund,
	JM Financial Credit Fund

</li>
                    </ul>
                    <h5>Category III AIF</h5>
                    <p className="bold-line">
                        Uses complex strategies and leverage to generate alpha. Ideal for market-savvy investors.
                    </p>
                    <ul>
                      <li><h6>Types</h6>Long-Short Equity Funds, Hedge Funds, Quant Funds, Arbitrage Funds.</li>
                      <li><h6>	Key Feature</h6>Can use leverage and derivatives; higher-risk.</li>
                      <li><h6>	Liquidity</h6>Quarterly or annual exits depending on scheme; open/closed-end.</li>
                      <li><h6>		Examples</h6>	Marcellus Long-Only Strategy,
	Tata Equity Plus Arbitrage,
	Avendus Absolute Return Fund,
	ASK India Select Fund,
	Alpha Alternatives
</li>
                    </ul>

                    
                    <h3 style={{color:'black'}}>Key Terminologies</h3>
                    <div className="plan-columns">
                        
                        <div>
                            <h5>1. 	Drawdown </h5>
                            <p>Capital is called in tranches rather than all at once
                            </p>
                            <h5>2. 	Vintage Year </h5>
                            <p>The year an AIF scheme begins deployment</p>
                        </div>
                        <div>
                            <h5>3. 	Hurdle Rate </h5>
                            <p>Minimum return after which performance fee is charged</p>
                            <h5>4. 	Catch-Up Clause </h5>
                            <p>Allows fund manager to earn full carry post-hurdle</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4>Why Invest in AIFs Through PSJ?</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 	•	Access to Top Funds  </li>
                                <li>✓ 	•	Independent Research  </li>
                                <li>✓ 	•	Investor Education  </li>
                                <li> ✓	•	Diversification Tools  </li>
                                <li> ✓  •	Negotiated Access  </li>	
                            </ul>
                        </div>
                    </div>


                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>AIF Investment Process at PSJ Capital Ventures</h3>
                        
                        <ul>
                            <li>✓ 	Discovery & Planning</li>
                            <li>✓ 	Fund Selection</li>
                            <li>✓ 		Documentation & Onboarding</li>
                            <li>✓ 		Capital Commitment & Drawdowns</li>
                            <li>✓ 		Monitoring & Reporting</li>
                            <li>✓ 		Exit Strategy & Returns</li>
                        </ul>
                        <p>
                            Let’s Build Your AIF Allocation We offer complete support — from shortlisting and onboarding to post-investment reporting and exit. Whether your goal is capital appreciation, income generation, or legacy diversification, PSJ Capital Ventures ensures your AIF exposure is high-conviction, risk-optimized, and professionally managed.
                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to= '/mutual-funds'><li>Mutual Funds →</li></Link>
                            <Link to= '/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                            <Link to= '/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                            <Link to= '/nri-corner'><li>NRI Corner →</li></Link>
                            <Link to= '/family-offices'><li>Family Offices →</li></Link>
                            <Link to= '/insurance'><li>Insurance →</li></Link>
                            <Link to= '/loan-syndication'><li>Loan Syndication →</li></Link>
                            <Link to= '/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                            <Link to= '/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                            <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
  )
}

export default AIF;